import { useCallback } from 'react';
import { useFetch } from './use-fetch';
import logger from '~/utils/logger';
import { HttpMethod } from './fetch';

type FormSubmitProps = {
  formData: {
    [propName: string]: any;
  };
  isInApp: boolean;
  contentURL: string;
};

/**
 * 15s 中台如果还没有结果，不再等待请求结果，直接fail
 */
const timeoutFunc = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(false);
    }, 15000);
  });
};

const FORM_PATH = 'https://heliophilia.lemon8-app.com/report/api/infringement/form';

export const useFormSubmit = () => {
  const fetch = useFetch();

  return useCallback(async (props: FormSubmitProps) => {
    const { formData } = props;

    let res: any;
    try {
      res = await Promise.race([
        fetch(FORM_PATH, {
          params: {
            formData,
          },
          method: HttpMethod.post,
        }),
        timeoutFunc(),
      ]);
      // 如果请求发送失败，比如断网情况直接将res赋值为false
    } catch (error) {
      logger.error(error, 'plugin report fetchFormSubmit api  /report/api/infringement/form error');
      res = false;
    }

    if (res && res.msg === 'success' && res.code === 'A00000') {
      return true;
    } else {
      return false;
    }
  }, []);
};
